export const port = process.env.PORT || 3111;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;




// WEBPACK FOOTER //
// ./config.js